import { beforeEnter } from '@/modules/relatorio-exportacao/locale';

const routes = [
    {
        path: '/relatorio-exportacao',
        name: 'RelatorioExportacao',
        component: () => import('@/modules/relatorio-exportacao/pages/RelatorioExportacao.vue'),
        beforeEnter,
        props: true,
        meta: {
            roles: ['ROLE_ADMINISTRATOR']
        }
    },
    {
        path: '/relatorio-exportacao/:id',
        name: 'RelatorioExportacaoDetalhe',
        component: () => import('@/modules/relatorio-exportacao/pages/RelatorioDetalhe.vue'),
        beforeEnter,
        props: true,
        meta: {
            roles: ['ROLE_ADMINISTRATOR']
        }
    }
];

export default routes;
